module.exports = __webpack_public_path__ + "static/media/sign-in-banner.665fa356.png";